<template>
  <Navbar :center-text="$t('TemplatesView.templates')"
          :message="this.message"
          :message-type="this.messageType">
  </Navbar>
  <div class="container mt-4">
    <div class="row justify-content-center">
      <div v-for="template in templates"
           class="col-sm-12 col-md-6 col-lg-5 mx-1 mb-4 cards-container justify-content-center align-items-center">
        <div :class="`card card-yellow text-center shadow-sm`">
          <div class="card-body">
            <h5 class="card-title">
              <i class="bi bi-file-post"></i>
              {{ template.title }}
            </h5>
            <p class="card-text">
              <embed :src="`https://canalls.uni-hohenheim.de/backend/index.php/documents/${template.file_id}`"
                     style="width:100%; height:650px;"/>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Footerbar></Footerbar>
</template>

<script>


import Navbar from "@/components/Navbar.vue";
import Footerbar from "@/components/Footerbar.vue";

export default {
  components: {Footerbar, Navbar},
  data() {
    return {
      message: null,
      messageType: null,
      templates: []
    }
  },
  mounted() {
    this.templates = [
      {
        title: "Moderation and Visualization for Group Events",
        file_id: "43fe23a3-3b69-4e2d-bb5c-373ac8d1e43f",
      },
      {
        title: "80 Tools for Participatory Development",
        file_id: "bfcfd64d-af80-4562-b55d-0bdf945781ff",
      },
    ];
  }
}
</script>
